import { render } from "./ModalForm.vue?vue&type=template&id=369d7712"
import script from "./ModalForm.vue?vue&type=script&lang=js"
export * from "./ModalForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nakarinjaiseengam/Works/STM/STM-POS/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__